export const printStyles = `
  @media print {
    .no-print,
    #navBar,
    nav,
    header,
    button,
    .fixed,
    [role="navigation"],
    [role="search"],
    form,
    .container > .bg-white > .flex:first-child,
    .z-30.sticky.top-0,
    .overflow-y-auto {
      display: none !important;
    }

    .container {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .print-expand {
      width: 100% !important;
      overflow: visible !important;
      page-break-inside: auto !important;
    }

    body {
      font-size: 11pt;
      color: #000;
      background: #fff;
      width: 100%;
      margin: 0;
      padding: 0;
    }

    h1, h2 {
      margin: 20px 0 10px;
      page-break-after: avoid;
      font-size: 16pt;
    }

    table {
      width: 100% !important;
      border-collapse: collapse !important;
      page-break-inside: auto !important;
      table-layout: fixed !important;
    }

    tr {
      page-break-inside: avoid !important;
      page-break-after: auto !important;
    }

    td, th {
      border: 1px solid #ddd !important;
      padding: 4px !important;
      text-align: left !important;
      font-size: 8pt !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      word-break: normal !important;
      hyphens: auto !important;
      white-space: normal !important;
      vertical-align: top !important;
      max-width: 100px !important;
      position: static !important;
      box-shadow: none !important;
    }

    td:first-child, th:first-child {
      max-width: 150px !important;
    }

    .flex.flex-col.gap-1 {
      display: block !important;
      font-size: 8pt !important;
      line-height: 1.1 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .flex.items-center.gap-2 span {
      font-size: 8pt !important;
      font-weight: normal !important;
      display: block !important;
    }

    .flex.items-center.gap-1.text-xs {
      font-size: 7pt !important;
      line-height: 1 !important;
      margin-top: 2px !important;
      overflow: hidden !important;
      max-height: 1em !important;
      white-space: nowrap !important;
    }

    .flex.items-center.gap-1.text-xs svg,
    .flex.items-center.gap-2 svg {
      display: none !important;
    }

    th {
      background-color: #f2f2f2 !important;
      font-weight: bold !important;
      font-size: 8pt !important;
      line-height: 1.2 !important;
      white-space: normal !important;
    }

    #unitTableRef {
      page-break-before: always;
    }

    .p-6, .pt-6, .px-6, .py-6 {
      padding: 10px !important;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    button.bg-white {
      padding: 0 !important;
      margin: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      line-height: 1 !important;
      font-size: 8pt !important;
      min-width: 0 !important;
    }
  }
`;
